import styled from 'styled-components';

import { Button, Card, Text, Box } from '@gympass/yoga';
import { AlertTriangle } from '@gympass/yoga-icons';

export const CriticalUserSection = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
  gap: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const CriticalUserSectionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const ButtonValidate = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px
    ${({ theme }) => theme.yoga.spacing.small}px;
  gap: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  width: ${({ theme }) => theme.yoga.spacing.xhuge}px;
  height: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  background: ${({ theme }) => theme.yoga.colors.primary};
`;

export const TextValidate = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.yoga.colors.white};
`;

export const StatusContainer = styled('div')`
  display: flex;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const StatusValidateContainer = styled(Box)`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  border: 1px solid ${({ theme }) => theme.yoga.colors.error};
  border-radius: ${({ theme }) => theme.yoga.radii.xsmall}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const StatusValidateIcon = styled(AlertTriangle)`
  fill: ${({ theme }) => theme.yoga.colors.error};
  width: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  height: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const StatusValidateText = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  color: ${({ theme }) => theme.yoga.colors.error};
`;

export const CriticalBadge = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  box-shadow: none;
  width: fit-content;
  gap: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
  border-radius: ${({ theme }) => theme.yoga.radii.xsmall}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  ${({ isCritical, theme }) =>
    isCritical
      ? `background: ${theme.yoga.colors.feedback.attention.light};`
      : `background: ${theme.yoga.colors.disabled};`};
`;

export const IsSignalCriticalText = styled(Text)`
  overflow: hidden;
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.text.primary};
  border-radius: ${({ theme }) => theme.yoga.radii.xsmall}px;
`;

export const CriticalTextObservation = styled(Text)`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  color: ${({ theme }) => theme.yoga.colors.text.secondary};
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
`;

export const CriticalTextObservationLink = styled(Button.Link)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  color: ${({ theme }) => theme.yoga.colors.deepPurple};
  white-space: nowrap;
  text-decoration: underline;
`;

export const StateOfLastForwardingContainer = styled(Box)`
  display: flex;
`;

export const ConfirmedAndForwarded = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.text.secondary};
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const ConfirmedAndNotForwarded = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.error};
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;
